import { createContext } from 'react';

const EditorUpdateContext = createContext((payload) => { });

export { EditorUpdateContext };
//# sourceMappingURL=editorUpdateContext.js.map
